const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/$id.holds.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllVenueHoldsQueryOptions } from '@api';
import { createTableQuerySchema, getTableParams } from '@common*';
import { createFileRoute } from '@tanstack/react-router';
const TABLE_ID_UPCOMING = 'upcomingHolds';
const TABLE_ID_PAST = 'pastHolds';
const searchSchema = createTableQuerySchema({
  tableIds: [TABLE_ID_UPCOMING, TABLE_ID_PAST]
});
export const Route = createFileRoute('/_rootLayout/venues/$id/holds')({
  validateSearch: search => searchSchema.parse(search),
  beforeLoad: () => {
    return {
      tableIdUpcoming: TABLE_ID_UPCOMING,
      tableIdPast: TABLE_ID_PAST
    };
  },
  loader: async ({
    context: {
      queryClient
    },
    params,
    location
  }) => {
    const tableParamsUpcoming = getTableParams(location.search, TABLE_ID_UPCOMING);
    const tableParamsPast = getTableParams(location.search, TABLE_ID_PAST);
    queryClient.ensureQueryData(getFindAllVenueHoldsQueryOptions(params.id, {
      type: 'UPCOMING',
      ...tableParamsUpcoming
    }));
    queryClient.ensureQueryData(getFindAllVenueHoldsQueryOptions(params.id, {
      type: 'PAST',
      ...tableParamsPast
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});